var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "wechat",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#303c42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15c0-3-3.13-5.5-7-5.5s-7 2.5-7 5.5 3.13 5.5 7 5.5a8.69 8.69 0 0 0 2.35-.32l2.65 1.32-.83-2.09A5.22 5.22 0 0 0 23.5 15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 13,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9.52v0c0-3.87-3.69-7-8.25-7S.5 5.63.5 9.5A6.68 6.68 0 0 0 3.73 15L2.5 17.5l2.85-1.63a9.46 9.46 0 0 0 3.4.63 9.75 9.75 0 0 0 1-.06"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.388d576e9831cb6f3d5175bd45e0a8cb.svg";
export { ForwardRef as ReactComponent };